<mat-card style="width:100%;height: 630px">
  <form #loginForm="ngForm" enctype="multipart/form-data">
    <mat-toolbar style="float:left;clear:both;width:100%;" color="secondary">
      <div style="width:90%;height:30px;float:left;clear:none">
        Currículum
        <span class="fill-remaining-space" style="margin-left: 20px">({{nom}})</span>
        <mat-card-content style="float:right;clear:both;width: 200px">
          <mat-select style="float:left;clear:none" [(ngModel)]="idioma" name="idioma" placeholder="Seleccionar idioma" (change)="this.canviar()">
            <mat-option value="ca">Català</mat-option>
            <mat-option value="en">Anglès</mat-option>
            <mat-option value="es">Castellà</mat-option>
            <mat-option value="pt">Portuguès</mat-option>
          </mat-select>
        </mat-card-content>
      </div>
      <div style="width:10%;float:left">
        <button mat-icon-button style="float: right; matInput margin-right:0" mat-icon-button (click)="tancar()"  matTooltip="Tancar"  aria-label="Tancar" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
        <button mat-icon-button style="float: right; matInput margin-right:0" mat-icon-button (click)="desar()"  matTooltip="Desar"  aria-label="Desar" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>  
    </mat-toolbar>

<mat-card-content style="float:left;clear:both;padding: 24px 5px" *ngIf="userCurr">
  <div *ngFor="let data of userCurr.data" style="float:left;clear:both;height: 150px;width:100%">
	  <span style="float:left;clear:both;width:100%">{{data.etiqueta}}</span>
    <mat-form-field style="float:left;clear:both;width:100%" *ngIf="data.camp !== 'filename'">
      <textarea matInput placeholder="" name="{{data.camp}}" [(ngModel)]="data.contingut" style="width: 95%;height:120px">
        {{data.contingut}}
      </textarea>
    </mat-form-field>
 <!--      <div style="float:left;clear:left; width:100%" *ngIf="data.camp === 'filename'">
  <div style="float:left;clear:left; width:100%;margin-bottom:20px;height:30px">
    <div class="lbl_dlg" style="padding-top:7px;float:left;clear:left;width:200px">Foto:</div>
    <div class="lbl_dlg" style="float:left;clear:none;margin-left:10px;margin-top:5px" *ngIf="userCurr.data.filename">
      <img alt="{{userCurr.data.name}}" title="{{userCurr.data.name}}" src="documents/curriculum/data.name"/>
    </div>
    <div class="lbl_dlg" style="margin-left:10px;padding-top:7px" *ngIf="userCurr.data.filename != ''">
      <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;margin-top: -20px;cursor:pointer" (click)="userCurr.data.filename = ''" color="primary">delete_forever</mat-icon>
    </div>
  </div>
  <div style="float:left;clear:left;width:100%">
    <div style="float:left;clear:left;position: absolute;width:100%;z-index:1;background-color: white">
     <div style="float:left;clear:none;padding-top:5px">Carregar una fotografia</div>
      <div style="float:left;clear:none">
        <label for="file">
          <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary">cloud_upload</mat-icon></label>
      </div>
    </div>
    <div style="float:left;clear:left;position: absolute;width:100%">
      <input mat-raised-button color="primary" type="file" filter="jpg;png;bmp;gif" style="width:80%" placeholder="" id="file" name="file" (change)="onFileChange($event)"/> (5Mb màx.)
    </div>
  </div> 
  </div>-->
  </div>
</mat-card-content>
</form>
</mat-card>

